/* eslint-disable */

import Phaser from 'phaser';
import { store } from '../stores/mainStore';
import { angleBetweenPoints, getDistance, pointAlongLine } from './helpers';
import { integration } from '../integration';
var m;
export class Cup {
	constructor(mgr) {
		m = mgr;
		store.m = m;
		this.cupSprite = null;
		this.cupHomeposition = { x: m.config.width / (m.landscape ? 4 : 3), y: m.config.height * 0.66 - 0 };
		this.cupHomeposition.y += m.pushDownAmount;
		this.cupReleasePosition = this.cupHomeposition;
		this.cupDownPosition = this.cupReleasePosition;
		this.diceLaunchPosition = this.cupReleasePosition;
		this.cupClicked = false;
	}

	create() {
		//this.cupSprite = m.scene.add.sprite(-100, m.config.height + 100, store.custom.cup + '_cup_sheet').setInteractive();
		this.cupSprite = m.scene.add.sprite(-100, m.config.height + 100, 'cup_sheet').setInteractive();
		this.setFrame(1);
		var myScale = 1.0;
		if (this.cupSprite.width != 180) myScale = 180 / this.cupSprite.width;
		myScale *= m.scaleFactor;
		this.cupScale = myScale;
		this.cupSprite.setScale(myScale); //force to be the size it was before in case of higher res source
		this.cupSprite.setOrigin(0.5, 0.05);
		this.cupSprite.inputEnabled = true;
		this.cupHeight = this.cupSprite.height * this.cupSprite.scaleY;
		this.cupSprite.input.draggable = true;

		this.arrowSprite = m.scene.add.sprite(this.cupHomeposition.x, this.cupHomeposition.y, 'common', 'cupArrow.png');
		this.arrowSprite.setOrigin(0.5, 1.1);
		this.cupSwirl = m.scene.add.sprite(this.cupSprite.x, this.cupSprite.y, 'swirl001');
		this.cupSwirl.setScale(m.oldAssetScaleFactor);
		this.cupSwirl.setOrigin(0.5, 0.275);
		this.waitForHandPointer = false;

		m.scene.input.setDraggable(this.cupSprite);
		this.cupSprite.on('dragstart', (pointer) => {
			if (m.cup.waitForHandPointer === true) return;
			if(store.tutorialMode && !m.cup.cupClicked)	//adamo cuptest
				return;

			if (m.handPointer) {
				if (m.handPointerTimer) clearTimeout(m.handPointerTimer);
				m.handPointer.destroy();
			}

			m.cup.clearCupDragAutoFireTimer();
			m.cup.startCupDragAutoFireTimer();

			if (!m.cup.cupClicked) this.processPointerDown(pointer);
		});
		m.scene.input.on('drag', (pointer, gameObject, dragX, dragY) => {
			if (gameObject != this.cupSprite) {
				// eslint-disable-line
				return;
			}
			if (m.cup.waitForHandPointer === true) return;
			if (m.cup.waitForFTUE === true)	return;

			if(store.tutorialMode && !m.cup.cupClicked)	//adamo cuptest
				return;

			m.cup.clearCupDragAutoFireTimer();

			if (m.handPointer) {
				if (m.handPointerTimer) {
					clearTimeout(m.handPointerTimer);
				}
				m.handPointer.destroy();
			}

			if (m.diceStatus === 'introToCup') return;
			if (m.diceStatus === 'launch' || m.diceStatus === 'launching') return;

			//if (store.tutorialMode && m.skipTutorial != null) m.skipTutorial.setAlpha(0);

			let flickDistance = -m.cup.cupHeight / 2; // -m.config.height * 0.02;
			let pullDistance = m.config.height - m.cup.cupHeight / 2 - m.cup.cupHomeposition.y;
			let yDistance = this.cupSprite.y - this.cupHomeposition.y;

			if (m.cup.cupSprite.y >= this.cupHomeposition.y + flickDistance * 1.0)
				gameObject.x = dragX;

			if (dragY >= this.cupHomeposition.y + flickDistance && dragY <= this.cupHomeposition.y + pullDistance) {
				gameObject.y = dragY;
			}
			this.pointCupTowardsAimPoint();

			if (true) {
				m.cup.clearCupDragAutoFireTimer();

				var x = pointer.position.x;
				var y = pointer.position.y;
				var l = store.tutorialMode ? 40 : 20;
				var r = store.tutorialMode ? 40 : 40;

				var left = x < l;
				var right = x > m.config.width - r;
				var bottom = y > m.config.height - m.cup.cupHeight * 0.3;
				var high = dragY < m.config.height * 0.15;
				if (left || right || bottom || high) {
					this.processCupPointerUp(left ? 'LEFT' : right ? 'RIGHT' : bottom ? 'BOTTOM' : 'HIGH');
					return;
				}

				var inBounds = Phaser.Geom.Rectangle.ContainsPoint(m.cup.cupSprite.getBounds(), pointer.position);
				if (inBounds === false) {
					this.processCupPointerUp('DRAG_OUT');
					return;
				}

				m.cup.startCupDragAutoFireTimer();
			}
		});
		this.cupSprite.on('dragend', (pointer) => {
			if (m.diceStatus === 'introToCup') return;
			if (m.readyToLaunch || m.diceStatus !== 'arrivedInCup') return;

			this.processCupPointerUp('DRAGEND');
		});

		this.cupSprite.on('pointerdown', (pointer) => {
			this.processPointerDown(pointer);
		});
		this.cupSprite.on('pointerup', (pointer) => {
			this.processCupPointerUp('CUP_POINTERUP');
		});

		this.cupSprite.on('pointerout', (pointer) => {
			console.log('POINTEROUT');

			pointer = m.scene.input.activePointer;
		});

		this.pointCupTowardsAimPoint();
		this.arrowSprite.setScale(1.0 * m.scaleFactor, 0);

		m.scene.input.on('pointerup', function (pointer) {
			if (m.cup && m.cup.cupSprite && m.cup.cupSprite.input) m.cup.cupSprite.input.draggable = true;
		});

		m.scene.input.dragDistanceThreshold = 4;
		m.scene.input.dragTimeThreshold = 50;

		m.scene.input.dragDistanceThreshold = 1;
		m.scene.input.dragTimeThreshold = 1;
	} //create();

	setFrame(frameNum) {
		this.frameNum = frameNum;
		this.cupSprite.setFrame(frameNum);
	}
	showDiceInCup() {
		if (m.cup.frameNum < 6) m.cup.setFrame(m.cup.frameNum + 6); //show same cup w/ little dice showing
	}
	hideDiceInCup() {
		if (m.cup.frameNum >= 6) m.cup.setFrame(m.cup.frameNum - 6); //show same cup w/ no little dice showing
	}
	doCupDragAutoFireTimer() {
		if (m.cupDragAutoFireTimer != null) m.cup.processCupPointerUp('TIMER');
	}
	startCupDragAutoFireTimer() {
	}
	clearCupDragAutoFireTimer() {
		if (m.cupDragAutoFireTimer != null) {
			clearTimeout(m.cupDragAutoFireTimer);
			m.cupDragAutoFireTimer = null;
		}
	}
	doCupNoticeMeTimer() {
		if (m.cupNoticeMeTimer != null) {
			m.cup.cupSprite.setScale(m.cup.cupScale);
			var evapTween = m.scene.tweens.add({
				targets: [m.cup.cupSprite],
				scaleX: m.cup.cupScale * 1.2,
				scaleY: m.cup.cupScale * 1.2,
				ease: 'Linear',
				delay: 0,
				duration: 150,
				yoyo: true,
				repeat: 0,
				onComplete: (tween, target) => {
					m.cup.cupSprite.setScale(m.cup.cupScale);
					var evapTween = m.scene.tweens.add({
						targets: [m.cup.cupSprite],
						scaleX: m.cup.cupScale * 1.2,
						scaleY: m.cup.cupScale * 1.2,
						ease: 'Linear',
						delay: 50,
						duration: 150,
						yoyo: true,
						repeat: 0,
						onComplete: (tween, target) => {
							m.cup.cupSprite.setScale(m.cup.cupScale);
							// if(!store.tutorialMode)
								m.cup.startCupNoticeMeTimer();	//restart it
						},
					});
				},
			});
		}
	}
	startCupNoticeMeTimer() {
		if(store.tutorialMode && (store.activeMatch.matchId === 'intro2' || store.activeMatch.matchId === 'intro'))
			return;
		m.cup.cupSprite.setScale(m.cup.cupScale);
		m.cupNoticeMeTimer = gameSetTimeout(m.cup.doCupNoticeMeTimer, store.tutorialMode ? 5000 : 60000);
	}
	clearCupNoticeMeTimer() {
		m.cup.cupSprite.setScale(m.cup.cupScale);
		if (m.cupNoticeMeTimer != null) {
			clearTimeout(m.cupNoticeMeTimer);
			m.cupNoticeMeTimer = null;
		}
	}

	waitForFTUE = false;
	processPointerDown(pointer) {
		if (m.diceStatus === 'introToCup') return;
		if (!m.readyToRoll) return;
		if (m.cup.waitForHandPointer === true) return;
		if (m.cup.waitForFTUE === true) 
			return;

		m.cup.cupSprite.input.draggable = true;
		m.cup.cupClicked = true;

		m.cup.cupDownPosition = { x: m.cup.cupSprite.x, y: m.cup.cupSprite.y };

		if (m.cupNoticeMeTimer != null) clearTimeout(m.cupNoticeMeTimer);

		if (m.handPointer) {
			if (m.handPointerTimer) {
				clearTimeout(m.handPointerTimer);
			}
			m.handPointer.destroy();
		}
		if (m.rollBannerTimer) clearTimeout(m.rollBannerTimer);

		store.tutorialState = '';
		m.startThrow(pointer);

		m.cupSwirlTimer = gameSetTimeout(m.cup.showCupSwirl, 400);
	}
	processCupPointerUp(reason) {
		if (m.cup.waitForFTUE === true) 
			return;
		this.cupClicked = false;
		m.cup.clearCupDragAutoFireTimer();

		this.arrowSprite.setScale(1.0 * m.scaleFactor, 0);

		if (m.readyToLaunch || m.diceStatus === 'launch' || m.diceStatus === 'launching') return;

		m.gameState.state = 'roll';
		if (m.diceStatus === 'arrivedInCup') {
			m.diceStatus = 'launch';
			this.launchCup();
		} else m.readyToLaunch = true;

		this.hideCupSwirl();

		if(store.activeMatch.matchId === 'intro') {
			window.WrapperApp.postMessage('tutorial-start?success=true');
		}
	}

	showCupSwirl() {
		if (!m.cup.cupSwirl) return;
		m.cup.cupSwirl.x = m.cup.cupSprite.x;
		m.cup.cupSwirl.y = m.cup.cupSprite.y;
		m.cup.cupSwirl.angle = m.cup.cupSprite.angle;
		m.cup.cupSwirl.setAlpha(1.0);
		m.cup.cupSwirl.anims.play('cupSwirl');

		m.cup.clearCupDragAutoFireTimer();
		m.cup.startCupDragAutoFireTimer();

		m.cup.pointCupTowardsAimPoint();
	}
	hideCupSwirl() {
		if (!m.cup.cupSwirl) return;
		if (m.cupSwirlTimer != null) {
			clearTimeout(m.cupSwirlTimer);
			m.cupSwirlTimer = null;
		}
		this.cupSwirl.setAlpha(0);
		if (!this.cupSwirl.anims) return;
		this.cupSwirl.anims.stop();

		this.arrowSprite.setScale(1.5 * m.scaleFactor, 0);
	}
	pointCupTowardsAimPoint() {
		this.cupSprite.angle = angleBetweenPoints({ x: this.cupSprite.x, y: this.cupSprite.y }, m.aimPoint) - 90;
		this.arrowSprite.x = this.cupSprite.x;
		this.arrowSprite.y = this.cupSprite.y;
		this.arrowSprite.angle = this.cupSprite.angle;
		var distance = getDistance(this.cupSprite.x, this.cupSprite.y, m.aimPoint.x, m.aimPoint.y);
		var maxDistance = getDistance(m.farthestLaunchPoint.x, m.farthestLaunchPoint.y, m.aimPoint.x, m.aimPoint.y);
		var scale = distance / maxDistance;
		scale *= 2.0 * m.scaleFactor;
		if (scale > 1.75 * m.scaleFactor) scale = 1.75 * m.scaleFactor;
		if (scale < 0.5 * m.scaleFactor) scale = 0.5 * m.scaleFactor;

		if (m.cup.cupSwirl && m.cup.cupSwirl.alpha > 0) this.arrowSprite.setScale(1.5 * m.scaleFactor, scale);

		this.cupSwirl.x = this.cupSprite.x;
		this.cupSwirl.y = this.cupSprite.y;
		this.cupSwirl.angle = this.cupSprite.angle;
	}
	hideCup() {
		this.cupSprite.x = this.cupSprite.x > m.config.width / 2 ? m.config.width + 400 : -400;
		this.cupSprite.y = m.config.height + 400;
	}
	returnCup = () => {
		if (store.activeMatch.currentHand.rollsRemaining === 0 || store.activeMatch.currentHand.best) {
			console.log('END of HAND')
			//console.log('returnCup call nextHand');
			//m.nextHand();
		} else if(/* !store.isProd && */ !store.tutorialMode && store.custom.usePopper) {
			m.popper.startRound()
		} else {
			this.reallyReturnCup();
		}
	};
	setTutorialStateTwoPair() {
		m.ui.showTutorialBanner();
		store.tutorialState = 'twopair';
		if(store.activeMatch.matchId === 'intro2')
			m.cup.waitForHandPointer = true;
		gameSetTimeout(m.cup.continueSetTutorialStateTwoPair, 1000);
	}
	continueSetTutorialStateTwoPair() {
		if (m.diceStatus === 'introToCup') 
			m.diceStatus = 'resolved';

		m.cup.showHandPointer();
	}

	waitForHandPointer = false;

	clearWaitForHandPointer() {
		m.cup.waitForHandPointer = false;
	}

	reallyReturnCup(noZoom) {
		if (store.tutorialMode && store.tutorialPreventRoll) {
			return;
		}
		console.log('reallyReturnCup');

		frameNum = store.activeMatch.currentHand.rollNumber >= 3 ? store.is1or3HandGame ? 1 : 4 : store.activeMatch.currentHand.rollsRemaining;

		var frameNum =
			store.activeMatch.currentHand.rollNumber >= 3 && !store.isEligibleForRewardRoll ? store.is1or3HandGame ? 1 : 4 : store.activeMatch.currentHand.rollsRemaining;
		this.setFrame(frameNum);
		var cupOffset = m.landscape ? 0.25 : 0.33;
		this.cupHomeposition.x =
			this.cupSprite.x > m.config.width / 2 ? m.config.width * (1.0 - cupOffset) : m.config.width * cupOffset;
		var angle = angleBetweenPoints({ x: this.cupHomeposition.x, y: this.cupHomeposition.y }, m.aimPoint) - 90;

		if (store.tutorialMode) {
			if (store.activeMatch.handNumber === 1 && store.activeMatch.currentHand.rollNumber === 0) {
				if (m.diceHand.areDiceOffScreen()) m.cup.showDiceInCup();
				m.cup.setTutorialStateTwoPair();
				return;
			}
			if (store.activeMatch.matchId === 'intro2' && store.activeMatch.handNumber === 1 && store.activeMatch.currentHand.rollNumber === 1)
				m.cup.waitForFTUE = true;
		}

		m.cup.cupSprite.x = m.cup.cupSprite.x > m.config.width / 2 ? m.config.width + 100 : -100;
		m.cup.cupSprite.y = m.config.height + 100;

		let handPointerWillShow =
			store.tutorialMode && !(store.activeMatch.handNumber === 3 && store.activeMatch.currentHand.rollNumber > 0);
		if (handPointerWillShow) {
			if (store.activeMatch.matchId === 'intro2' 
			&& store.activeMatch.handNumber === 1 
			&& store.activeMatch.currentHand.rollNumber === 1)
				m.cup.waitForHandPointer = false;
			else 
				m.cup.waitForHandPointer = true;
			// gameSetTimeout(m.cup.clearWaitForHandPointer, 700);
		}

		m.scene.tweens.add({
			targets: [this.cupSprite],
			x: this.cupHomeposition.x,
			y: this.cupHomeposition.y,
			angle: angle,
			ease: 'Linear',
			duration: 300,
			repeat: 0,
			completeDelay: 0,
			onComplete: (tween, target) => {
				if (m.diceHand.areDiceOffScreen()) 
					m.cup.showDiceInCup();

				if (store.tutorialMode) {
					if (store.activeMatch.currentHand.rollNumber === 0) 
						m.ui.showTutorialBanner();

					if (store.activeMatch.matchId === 'intro2' && store.activeMatch.handNumber === 1 
							&& store.activeMatch.currentHand.rollNumber === 1)
						m.ui.showFTUE2RollsHint();
					else { 
						if (handPointerWillShow) 
							this.showHandPointer();

						this.startCupNoticeMeTimer();
					}
				} else {
					// m.handPointerTimer = gameSetTimeout(() => {
					// 	this.showHandPointer();
					// }, 3000);

					//temporarily turn off for prod push 3/3/21
					this.startCupNoticeMeTimer();
				}

				if (m.diceStatus !== 'resolved' ||
					store.activeMatch.currentHand.rollNumber === 0 ||
					store.activeMatch.currentHand.rollsRemaining < 1 ||
					store.activeMatch.currentHand.best
				)
					return;

				if (!store.tutorialMode) {
					if (store.activeMatch.currentHand.rollNumber > 0) {
						m.ui.showSelectDiceMsg();
						m.ui.showZoomButton();
					}
				}
				console.log('reallyReturnCup complete');
			},
		});
	}

	reallyFakeReturnCup(animate) {
		var frameNum;
		if(!store.pokerRush) {
			frameNum = store.activeMatch.currentHand.rollNumber >= 3 ? store.is1or3HandGame ? 1 : 4 : store.activeMatch.currentHand.rollsRemaining;
			if(store.activeMatch.matchId === 'intro')
				frameNum = 4;
		} else 
			frameNum = 4;
		
		this.setFrame(frameNum);

		if(store.pokerRush)
			m.cup.showDiceInCup();

		var cupOffset = m.landscape ? 0.25 : 0.33;
		this.cupHomeposition.x =
			this.cupSprite.x > m.config.width / 2 ? m.config.width * (1.0 - cupOffset) : m.config.width * cupOffset;
		var angle = angleBetweenPoints({ x: this.cupHomeposition.x, y: this.cupHomeposition.y }, m.aimPoint) - 90;

		m.cup.cupSprite.x = m.cup.cupSprite.x > m.config.width / 2 ? m.config.width + 100 : -100;
		m.cup.cupSprite.y = m.config.height + 100;

		if (store.tutorialMode) {
			if (store.activeMatch.matchId === 'intro' && m.diceStatus != 'introToCup') m.cup.showDiceInCup();
			else if (store.activeMatch.matchId != 'intro' && m.diceHand.areDiceOffScreen()) m.cup.showDiceInCup();
			else if (store.activeMatch.matchId === 'intro2') m.cup.showDiceInCup();
		}

		if (animate) {
			m.scene.tweens.add({
				targets: [this.cupSprite],
				x: this.cupHomeposition.x,
				y: this.cupHomeposition.y,
				angle: angle,
				ease: 'Linear',
				duration: 300,
				repeat: 0,
				completeDelay: 0,
				onComplete: () => {
					if(store.activeMatch.matchId === 'tutorial')
						this.startCupNoticeMeTimer();

				},
			});
		} else {
			this.cupSprite.x = this.cupHomeposition.x;
			this.cupSprite.y = this.cupHomeposition.y;
			this.angle = angle;
			if (store.tutorialMode && (store.activeMatch.matchId === 'intro' || store.activeMatch.matchId === 'intro2')) {
				m.cup.showHandPointer();
			}
		}
		console.log('reallyFakeReturnCup complete');
	}

	handPointerFlick = false;
	showHandPointer() {
		if (m.handPointer) {
			m.handPointer.destroy();
		}

		if(store.activeMatch.matchId === 'tutorial') {
			m.cup.waitForHandPointer = false;
			return;
		}

		if (
			m.diceStatus !== 'resolved' ||
			Math.floor(m.cup.cupSprite.x) !== Math.floor(m.cup.cupHomeposition.x) ||
			Math.floor(m.cup.cupSprite.y) !== Math.floor(m.cup.cupHomeposition.y)
		)
			return;
		if (store.activeMatch.handNumber === 3 && store.activeMatch.currentHand.rollNumber > 0) return;

		m.cup.handPointerFlick = !m.cup.handPointerFlick;

		m.handPointer = m.scene.add.container(m.cup.cupHomeposition.x, m.cup.cupHomeposition.y);

		var cupOutline = m.scene.add.sprite(0, 0, 'common', 'cupOutline.png');
		cupOutline.setOrigin(0.47, 0.15);
		cupOutline.setScale(m.cup.cupSprite.scale);
		cupOutline.angle = m.cup.cupSprite.angle;
		m.handPointer.add(cupOutline);

		var pointerHand = m.scene.add.sprite(
			m.cup.cupHomeposition.x > m.config.width / 2 ? 110 * m.scaleFactor : 70 * m.scaleFactor,
			120 * m.scaleFactor,
			'hand'
		);
		pointerHand.setScale(0.65 * m.scaleFactor);
		m.handPointer.add(pointerHand);

		pointerHand.anims.play('handPoint');

		m.cup.waitForHandPointer = false;

		if (m.cup.handPointerFlick) {
			var deltaX = 50; // * m.scaleFactor;
			var targetX = m.cup.cupHomeposition.x > m.config.width / 2 ? +-deltaX : deltaX;
			var targetY = -m.cup.cupSprite.height;
			var oldX = cupOutline.x,
				oldY = cupOutline.y;
			var thisTween = m.scene.tweens.add({
				targets: [cupOutline],
				x: targetX,
				y: targetY,
				ease: 'Linear',
				delay: 1000,
				duration: 150,
				repeat: 0,
				completeDelay: 0,
				onComplete: () => {
					if (store.tutorialMode && store.activeMatch.matchId === 'intro') m.cup.waitForHandPointer = false;
					if (store.tutorialMode && store.activeMatch.matchId === 'intro2') m.cup.waitForHandPointer = false;

					var deltaX = 10; // * m.scaleFactor;
					var tx = m.cup.cupHomeposition.x > m.config.width / 2 ? targetX + deltaX : targetX - deltaX;
					var ty = -m.cup.cupSprite.height * 0.75;
					m.scene.tweens.add({
						targets: [cupOutline],
						x: tx,
						y: ty,
						ease: 'Linear',
						duration: 150,
						yoyo: true,
						repeat: 0,
						completeDelay: 0,
						onComplete: () => {
							m.handPointerTimer = gameSetTimeout(m.cup.showHandPointer, 1000);
						},
					});
				},
			});
			var offsetX = m.cup.cupHomeposition.x > m.config.width / 2 ? +-deltaX : deltaX;
			var targetX2 = pointerHand.x + offsetX;
			var targetY2 = pointerHand.y - m.cup.cupSprite.height;
			var oldX2 = pointerHand.x,
				oldY2 = pointerHand.y;
			m.scene.tweens.add({
				targets: [pointerHand],
				x: targetX2,
				y: targetY2,
				ease: 'EaseOut',
				delay: 1000,
				duration: 150,
				repeat: 0,
				completeDelay: 0,
				onComplete: () => {
					pointerHand.setFrame(0);
				},
			});
		} else {
			var deltaX = 60; // * m.scaleFactor;
			var targetX = m.cup.cupHomeposition.x > m.config.width / 2 ? +deltaX : -deltaX;
			var targetY = m.cup.cupSprite.height;
			var oldX = cupOutline.x,
				oldY = cupOutline.y;
			var thisTween = m.scene.tweens.add({
				targets: [cupOutline],
				x: targetX,
				y: targetY,
				ease: 'EaseOut',
				delay: 1000,
				duration: 500,
				repeat: 0,
				completeDelay: 0,
				onComplete: () => {
					if (store.tutorialMode && store.activeMatch.matchId === 'intro') m.cup.waitForHandPointer = false;
					if (store.tutorialMode && store.activeMatch.matchId === 'intro2') m.cup.waitForHandPointer = false;
					m.scene.tweens.add({
						targets: [cupOutline],
						x: oldX,
						y: oldY,
						ease: 'Linear',
						delay: 250,
						duration: 250,
						repeat: 0,
						completeDelay: 0,
						onComplete: () => {
							m.handPointerTimer = gameSetTimeout(m.cup.showHandPointer, 1000);
						},
					});
				},
			});
			var offsetX = m.cup.cupHomeposition.x > m.config.width / 2 ? +deltaX : -deltaX;
			var targetX2 = pointerHand.x + offsetX;
			var targetY2 = pointerHand.y + m.cup.cupSprite.height;
			var oldX2 = pointerHand.x,
				oldY2 = pointerHand.y;
			m.scene.tweens.add({
				targets: [pointerHand],
				x: targetX2,
				y: targetY2,
				ease: 'EaseOut',
				delay: 1000,
				duration: 500,
				repeat: 0,
				completeDelay: 0,
				onComplete: () => {
					pointerHand.setFrame(0);
					m.scene.tweens.add({
						targets: [pointerHand],
						x: oldX2,
						y: oldY2,
						ease: 'Linear',
						delay: 750,
						duration: 750,
						repeat: 0,
						completeDelay: 0,
					});
				},
			});
		}
	}

	launchCup = () => {
		m.playAudio('diceRoll');
		m.cup.hideDiceInCup();

		store.tutorialState = '';
		var aimPoint = m.aimPoint;
		m.cup.cupReleasePosition = { x: m.cup.cupSprite.x, y: m.cup.cupSprite.y };
		var distance = getDistance(this.cupSprite.x, this.cupSprite.y, aimPoint.x, aimPoint.y);
		var travel = (this.cupHeight * 1.5) / distance;
		if (travel > 0.9) travel = 0.9;
		var targetPoint = pointAlongLine(travel, this.cupSprite.x, this.cupSprite.y, aimPoint.x, aimPoint.y);
		m.scene.tweens.add({
			targets: [this.cupSprite],
			x: targetPoint.x,
			y: targetPoint.y,
			ease: 'Linear',
			duration: 50,
			repeat: 0,
			completeDelay: 0,
			onComplete: () => {
				m.diceHand.launchDice();
			},
		});
		return;
	};
}
